import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FrameTooBigExceptionClass;
function FrameTooBigException() {
  if (FrameTooBigExceptionClass === VOID) {
    class $ extends Exception() {
      static f5h(frameSize, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.zd(cause);
        captureStack($this, $this.e5h_1);
        $this.d5h_1 = frameSize;
        delete $this.message;
        return $this;
      }
      r() {
        var sizeSuffix = this.d5h_1 >= 0n ? ': ' + this.d5h_1.toString() : '';
        return 'Frame is too big' + sizeSuffix;
      }
      q13() {
        return FrameTooBigException().f5h(this.d5h_1, this);
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'FrameTooBigException', VOID, VOID, [CopyableThrowable()]);
    FrameTooBigExceptionClass = $;
  }
  return FrameTooBigExceptionClass;
}
//region block: exports
export {
  FrameTooBigException as FrameTooBigException1rgdafsgu31sm,
};
//endregion

//# sourceMappingURL=FrameTooBigException.mjs.map
